import React, {useState} from 'react';
import Modal from '../../component/Inc/Modal';
import Upload from '../../component/Inc/Upload';

function PopManagingCompany(props) {
  const {open, close} = props;
  const [selectedItem, setSelectedItem] = useState(null);
  const listItems = ['자랑 제본소', '자랑 제본소', '자랑 제본소', '자랑 제본소', '자랑 제본소', '자랑 제본소', '자랑 제본소'];
  const handleClick = (index) => {
    setSelectedItem(index);
  };
  return (
    <Modal open={open} close={close} type="com_input pop_managing_company">
      <h2 className="pop_tit">제작처 관리</h2>
      <div className="content_container scroll">
        <ul className="com_input_sec">
          <li className="tit_field top">
            과목 선택
            <button className="com_btn gray xs">+ 제작처 추가</button>
          </li>
          <li>
            <ul className="com_scroll_list pick">
              {listItems.map((item, index) => (
                <li key={index} className={`item ${selectedItem === index ? 'selected' : ''}`} onClick={() => handleClick(index)}>
                  {item}
                </li>
              ))}
            </ul>
          </li>
          <hr className="com_divider type_inner" />
          <li className="tit_field">제작처 목록</li>
          <li className="input_field">
            <input type="text" className="input lightGray" defaultValue={`제작처 명 입력`} />

            <button className="com_btn gray xs">제작처 삭제</button>
          </li>
          <table className="com_board_list type_row">
            <colgroup>
              <col width="28%" />
              <col width="60%" />
            </colgroup>
            <tbody>
              <tr>
                <th>대표자</th>
                <td>
                  <div className="com_input_wrap flex_row">
                    <input type="text" className="input" defaultValue={`김대표`} />
                  </div>
                </td>
              </tr>
              <tr>
                <th>대표 전화번호</th>
                <td>
                  <div className="com_input_wrap flex_row">
                    <input type="text" className="input" defaultValue={`02-1234-1324`} />
                    <input type="text" className="input" defaultValue={`02-1234-1324`} />
                  </div>
                </td>
              </tr>
              <tr>
                <th>1 담당자 이름</th>
                <td>
                  <div className="com_input_wrap flex_row">
                    <input type="text" className="input" defaultValue={`김당담 과장`} />
                  </div>
                </td>
              </tr>

              <tr>
                <th rowSpan="2">전화번호 / 이메일</th>
                <td>
                  <div className="com_input_wrap flex_row">
                    <input type="text" className="input" defaultValue={``} />
                  </div>
                </td>
              </tr>
              <tr>
                <td className="border_left">
                  <div className="com_input_wrap flex_row">
                    <input type="text" className="input" defaultValue={``} />
                    <button className="btn_add"></button>
                  </div>
                </td>
              </tr>
              <tr>
                <th rowSpan="2">사업장 주소</th>
                <td>
                  <div className="com_input_wrap flex_row">
                    <input type="text" className="input" defaultValue={``} />
                    <button className="com_btn gray s wl">우편번호</button>
                  </div>
                </td>
              </tr>
              <tr>
                <td className="border_left">
                  <input type="text" className="input full" defaultValue={`상세 주소 입력`} />
                </td>
              </tr>
              <tr>
                <th>사업자 등록증</th>
                <td>
                  <div className="com_input_upload">
                    <Upload title="파일 등록" className="com_btn gray s wl" />
                    <p className="file">
                      <span className="txt">File name.pdf</span>
                      <button type="button" className="btn_del_file" onClick={() => {}}></button>
                      <button type="button" className="btn_down" onClick={() => {}}></button>
                    </p>
                  </div>
                </td>
              </tr>
              <tr>
                <th>노출 여부</th>
                <td>
                  <div className="com_input_wrap flex_row">
                    <div className="check">
                      <input type="radio" name="rdo" id="rdo_01" className="com_chk circle" />
                      <label htmlFor="rdo_01">노출</label>
                      <input type="radio" name="rdo" id="rdo_02" className="com_chk circle" />
                      <label htmlFor="rdo_02">미노출</label>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <li className="tit_field">제작 계약 조건</li>
          <table className="com_board_list">
            <colgroup>
              <col width="90" />
              <col width="55" />
              <col width="auto" />
              <col width="80" />
              <col width="60" />
              <col width="80" />
              <col width="80" />
              <col width="80" />
              <col width="40" />
            </colgroup>
            <thead>
              <tr>
                <th>~ 부수</th>
                <th>페이지</th>
                <th>교재명</th>
                <th>종이</th>
                <th>인쇄</th>
                <th>판형(크기)</th>
                <th>공급가</th>
                <th>VAT 포함</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>300~500</td>
                <td>304</td>
                <td>
                  이지웨이 화법·작문
                  <br />
                  (2024학년도)
                </td>
                <td>80미색 모조</td>
                <td>흑백</td>
                <td>225*300</td>
                <td>1,177,200</td>
                <td>1,294,920</td>
                <td>
                  <button className="btn btn_minus_gray" />
                </td>
              </tr>
              <tr>
                <td>500~600</td>
                <td>304</td>
                <td>
                  이지웨이 화법·작문
                  <br />
                  (2024학년도)
                </td>
                <td>80미색 모조</td>
                <td>4도 컬러</td>
                <td>225*300</td>
                <td>1,177,200</td>
                <td>1,177,200</td>
                <td>
                  <button className="btn btn_minus_gray" />
                </td>
              </tr>
              <tr>
                <td>600~1000</td>
                <td>304</td>
                <td>
                  이지웨이 화법·작문
                  <br />
                  (2024학년도)
                </td>
                <td>80미색 모조</td>
                <td>흑백</td>
                <td>225*300</td>
                <td>1,177,200</td>
                <td>1,294,920</td>
                <td>
                  <button className="btn btn_minus_gray" />
                </td>
              </tr>
            </tbody>
          </table>
          <button className="btn btn_add_gray btn_bar"></button>
          <div className="btn_container">
            <button className="com_btn orange xs">등록</button>
          </div>
        </ul>
      </div>
    </Modal>
  );
}

export default PopManagingCompany;
